import styled from "styled-components";

interface Props {
  children: any;
  direction?: "column" | "row";
  justify?:
    | "flex-start"
    | "center"
    | "flex-end"
    | "space-between"
    | "space-evenly";
  alignItems?: "flex-start" | "center" | "flex-end";
  flexWrap?: "wrap" | "nowrap";
}

const Grid = (props: Props) => {
  const { children, ...rest } = props;

  const Wrapper = styled.div<Props>`
    display: flex;
    flex-direction: ${({ direction }) => direction || "column"};
    align-items: ${({ alignItems }) => alignItems || "flex-start"};
    justify-content: ${({ justify }) => justify || "flex-start"};
    flex-wrap: ${({ flexWrap }) => flexWrap || "nowrap"};
  `;

  return <Wrapper {...rest}>{children}</Wrapper>;
};

export default Grid;
